import React from 'react';

import moment, {type Moment} from 'moment-tz';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {getRemainingTime} from 'app/general/dates';
import updateIntervalEnhancer, {
  type UpdateIntervalEnhancerProps,
} from 'app/general/updateIntervalEnhancer';
import {gt} from 'app/utils/i18n';

import type {OverlayPlacementType} from 'app/general/overlays';

type Props = {
  className?: string;
  timestamp: string | Moment;
  wrapText?: string;
  wrapTextFn?: (string) => React.ReactNode;
  wrapTooltip?: (string) => React.ReactNode;
  tooltipPlacement?: OverlayPlacementType;
};

const BaseCountdown = ({
  className,
  timestamp,
  wrapText,
  wrapTextFn,
  tooltipPlacement,
  wrapTooltip,
}: Props & UpdateIntervalEnhancerProps) => {
  const elapsedTime = getRemainingTime(timestamp, true);
  const formattedTime = moment(timestamp).format('lll');

  return (
    <LazyTooltip
      placement={tooltipPlacement}
      tooltip={
        wrapTooltip != null ? (
          wrapTooltip(formattedTime)
        ) : (
          <span>{formattedTime}</span>
        )
      }
    >
      <span className={className}>
        {wrapTextFn != null
          ? wrapTextFn(elapsedTime)
          : wrapText != null
          ? gt(wrapText, elapsedTime)
          : elapsedTime}
      </span>
    </LazyTooltip>
  );
};

export const CountdownTime = updateIntervalEnhancer<Props>(
  BaseCountdown,
  5 * 1000
);
